import FiltersButton from "PFApp/components/filters/filters_button";
import PageTabs from "PFComponents/page/page_tabs";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { PermissionRule } from "PFTypes";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./tx_tabs.module.scss";

const TxTabs = ({ tab, setTab, toggleFilters, filtersAreClear }) => {
  const { data: currentProfile } = useCurrentProfile();
  const { t } = useTranslation("feed");

  const taskListPermission =
    currentProfile.permissions_group &&
    currentProfile.permissions_group.permissions.find(({ name }) => name === PermissionRule.TaskList);
  const canTaskList = taskListPermission && taskListPermission.permitted;

  const tabsItems = canTaskList
    ? [
        { id: "my_feed", displayElement: t("myFeed").toUpperCase() },
        { id: "my_activities", displayElement: t("myActivities").toUpperCase() },
        { id: "all_activities", displayElement: t("all").toUpperCase() }
      ]
    : [
        { id: "my_feed", displayElement: t("myFeed").toUpperCase() },
        { id: "my_activities", displayElement: t("myActivities").toUpperCase() }
      ];

  const changeTab = (item) => {
    setTab(item.id);
  };

  return (
    <div>
      <PageTabs
        rootClassName={css.pageTabs}
        handleClick={(item) => changeTab(item)}
        items={tabsItems}
        active={tab}
      />
      <div className={css.filtersButton}>
        <FiltersButton filtersAreClear={filtersAreClear} onClick={toggleFilters} withLabel />
      </div>
    </div>
  );
};

TxTabs.propTypes = {
  fetchActivities: PropTypes.func,
  tab: PropTypes.string,
  setTab: PropTypes.func,
  toggleFilters: PropTypes.func,
  showFilters: PropTypes.bool,
  filtersAreClear: PropTypes.bool
};

export default TxTabs;
